export default "__VITE_ASSET__zByVdHCR__"